/**
 * Settings.tsx · 09_APP · OS-006 · 2026-10-20
 * Her ask: "maybe we should have a settings tab on here... we could start putting our settings in there.
 * Like one setting could be the option to be light or dark." (D-0072)
 * Second setting, same day: put C2C OS on her phone, because Chrome did not offer it on its own.
 */
import { useEffect, useState } from "react";
import { canInstall, getTheme, install, isInstalled, setTheme, type Theme } from "../lib/theme";

export function Settings() {
  const [theme, setT] = useState<Theme>(getTheme());
  const [installable, setInstallable] = useState(canInstall());
  const [installed, setInstalled] = useState(isInstalled());

  useEffect(() => {
    const on = () => setInstallable(canInstall());
    window.addEventListener("c2c-installable", on);
    return () => window.removeEventListener("c2c-installable", on);
  }, []);

  function pick(t: Theme) { setTheme(t); setT(t); }

  return (
    <main className="settings">
      <h2 className="sec">Settings</h2>

      <section className="set-card">
        <h3>Appearance</h3>
        <p>Choose what is easier on your eyes. This phone or computer remembers it.</p>
        <div className="seg" role="radiogroup" aria-label="Appearance">
          <button role="radio" aria-checked={theme === "light"} className={theme === "light" ? "on" : ""} onClick={() => pick("light")}>Light</button>
          <button role="radio" aria-checked={theme === "dark"} className={theme === "dark" ? "on" : ""} onClick={() => pick("dark")}>Dark</button>
        </div>
      </section>

      <section className="set-card">
        <h3>Put C2C OS on your phone</h3>
        {installed ? (
          <p>It is already on this phone. You are using it now.</p>
        ) : installable ? (
          <>
            <p>One tap puts the C2C OS icon on your home screen.</p>
            <button className="scan-btn" onClick={async () => { if (await install()) setInstalled(isInstalled()); }}>Add to my phone</button>
          </>
        ) : (
          <ol className="howto">
            <li><b>Android, in Chrome:</b> tap the three dots at the top right, then <b>Add to Home screen</b> or <b>Install app</b>.</li>
            <li><b>iPhone, in Safari:</b> tap the Share button at the bottom, then <b>Add to Home Screen</b>.</li>
            <li>Then open C2C OS from the new icon on your home screen.</li>
          </ol>
        )}
      </section>
    </main>
  );
}
